import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'semantic-ui-react';
import css from './ServicesCardHeader.scss';
import WaitingRoom from './WaitingRoom';
import { SFEntityID } from 'utils/types';
import WaitingRoomLink from 'common/WaitingRoomLink';

export default class ServicesCardHeader extends React.Component {

  get imageStyle() {
    const imageURL = `../instructor/photo.html?type=S&size=F&id=${encodeURIComponent(this.props.serviceUuid)}`;
    return { backgroundImage: `url(${imageURL})` };
  }

  render() {
    const { kioskQueueSize, kioskMaxWaitTime, kioskId, displayStudentQueue, isServiceMember, kioskType } = this.props;
    return (
      <Card.Header className={css['card-header-container']}>
        <div className={css["card-header-image"]} style={this.imageStyle} />
        <div className={css['card-header-info']}>
          <WaitingRoom kioskQueueSize={kioskQueueSize}
                       kioskMaxWaitTime={kioskMaxWaitTime}
                       kioskId={kioskId}
                       displayStudentQueue={displayStudentQueue}
                       isServiceMember={isServiceMember}
                       compact
                       kioskType={kioskType}/>
          <WaitingRoomLink checkedIntoService={this.props.checkedIntoService}
                           className={css['waiting-room-link']}
                           isStudent={this.props.isStudent}
                           kioskId={kioskId}
                           serviceId={this.props.serviceId}
                           serviceName={this.props.serviceName}
                           virtualCheckInEnabled={this.props.virtualCheckInEnabled}
                           virtualCheckInOpen={this.props.virtualCheckInOpen} />
        </div>
      </Card.Header>
    );
  }
}

ServicesCardHeader.propTypes = {
  serviceId: SFEntityID.isRequired,
  serviceUuid: PropTypes.string.isRequired,
  serviceName: PropTypes.string.isRequired,
  kioskQueueSize: PropTypes.number,
  kioskMaxWaitTime: PropTypes.number,
  kioskId: PropTypes.number,
  displayStudentQueue: PropTypes.bool,
  isServiceMember: PropTypes.bool.isRequired,
  kioskType: PropTypes.string,
  isStudent: PropTypes.bool,
  virtualCheckInEnabled: PropTypes.bool,
  checkedIntoService: PropTypes.bool,
  virtualCheckInOpen: PropTypes.bool
};
